import { useCallback, useMemo, useState } from 'react';
import { usePromoConditionsStateTypes } from '../PromoConditionsAccordion.types';

export function usePromoConditionsState(): usePromoConditionsStateTypes {
	const [isOpenedPromoAccordion, setOpened] = useState<boolean>(true);
	const [promoAccordionWrapperHeight, setPromoAccordionWrapperHeight] = useState<number>(0);
	const togglePromoAccordion = useCallback(() => {
		setOpened((prev) => !prev);
	}, []);

	return useMemo(
		() => ({
			togglePromoAccordion,
			setOpened,
			isOpenedPromoAccordion,
			promoAccordionWrapperHeight,
			setPromoAccordionWrapperHeight,
		}),
		[togglePromoAccordion, setOpened, isOpenedPromoAccordion, promoAccordionWrapperHeight, setPromoAccordionWrapperHeight],
	);
}
